import microuniversoApi from "app/api/microuniversoApi"
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"


import globalMU from "globalMU"

declare var window:any

export type SubstituirDataMarcadaDataPrevisaoEntregaItensInput = {
    dataMarcadaEntrega: string
}

export async function substituirDataMarcadaDataPrevisaoEntregaItens(input: SubstituirDataMarcadaDataPrevisaoEntregaItensInput) {
    try {
        globalMU.blockUI({tryPassiveLoading: true})

        const orcamentoAtualizado = await microuniversoApi.Orcamento.substituirDataMarcadaDataPrevisaoEntregaItens(
            store.getState().orcamento.IdentificadorOrcamento,input.dataMarcadaEntrega
        )
    
        const atualizarOrcamentoLegado = () => {
            const orcamentoLegado = window.orcamentoController.model
            orcamentoLegado.atualizar(orcamentoAtualizado)
        }
        
        atualizarOrcamentoLegado()
    } finally {
        globalMU.unblockUI()
    }
}